import UaBrowser, { getLanguage, isWebview, isWechatMiniapp } from './browser';

const instance = new UaBrowser();

function Wrap(ua?: string) {
    return instance.getEnv(ua);
}

Wrap.isWebview = isWebview;
Wrap.isWechatMiniapp = isWechatMiniapp;
Wrap.getLanguage = getLanguage;

// 获取当前浏览器名称
export const getBrowserName = () => {
    return Wrap().browser;
};

export const isSafari = getBrowserName() === 'Safari';

export const isFirefox = getBrowserName().includes('Firefox');

const isIPad = () => {
    const ua = navigator.userAgent.toLowerCase();
    const maxTouch = navigator.maxTouchPoints || 0;
    const dpr = window.devicePixelRatio || 1;
    const width = Math.min(window.screen.width, window.screen.height);

    // 1. iPad / iPadOS（iPadOS 13+ 会伪装成 Mac）
    if (/ipad/.test(ua) || (/macintosh/.test(ua) && maxTouch > 1)) {
        return true;
    }

    // 2. Android 平板（非手机）
    if (/android/.test(ua) && !/mobile/.test(ua)) {
        return true;
    }

    // 3. Windows / Linux / X11 平板（触屏设备）
    if ((/windows/.test(ua) || /linux/.test(ua) || /x11/.test(ua)) && maxTouch > 1) {
        // 增加 DPI 判断：一般平板 >= 1.5，触屏电脑多为 1.0~1.25
        const isHighDPI = dpr >= 1.5;
        // 宽度小于 1280 且高 DPI 视作平板，否则视作触屏电脑
        return width < 1280 && isHighDPI;
    }

    return false;
};

/**
 * 判断是否是平板设备
 */
export const isPad = isIPad();
